export const getPaymentPlansRoute = '/payments/plans/';
export const postPaymentSubscriptionRoute = '/payments/subscribe/';
export const createUpdateSubscriptionRoute = '/employer/company/billing/subscribe/';
export const updateSubscriptionRoute = '/employer/company/billing/subscribe/v2/';
export const addPaymentInformationRoute = '/employer/attach-payment-method/';
export const deletePaymentInformationRoute = '/employer/payment-method/delete';
export const setDefaultPaymentInformationRoute = '/employer/payment-method/set-default/';
export const postEnterprisePaymentSubscriptionRoute = '/payments/subscribe/enterprise/';
export const getCurrentPaymentPlan = '/payments/plans/current/';
export const getCurrentCompanyPaymentPlan = '/enterprise/payments/plans/current/';
export const getPaymentMethodsRoute = '/employer/payment-method/';
export const getPayementInfoRoute = '/employer/payment-method/';
export const getInvoicesRoute = '/payments/billing/invoices/';
export const requestEnterpriseInfoRoute = '/employer/enterpriseinfo/';
export const enterpriseCompaniesPlanCurrent = '/employer/enterprise-plans/current/';
export const enterpriseUpdateCompaniesPlan = '/enterprise/manage/company-plan/';
export const enterpriseMoveCompaniesPlan = '/enterprise/move-plan/';
export const enterpriseUpdateBillingCycle = '/enterprise/update/billing-cycle/';
export const enterpriseGetBillingCycle = '/enterprise/get/subscription/';
export const enterpriseTotalAggragate = '/enterprise/company/plan/details/';
export const enterpriseReactivateSubscriptipon = '/enterprise/reactivate/subscription/';
export const employerBillingTransitionRoute = '/employer/billing-transition/';
export const getPlanEstimationRoute = '/employer/new-plan-estimation/get/';

